import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { hideModal } from 'actions/modalActions';
import { Button, Layout, Modal, Typography } from '@hub-mono/ui';
import { useModalOffset } from './useModalOffset';
import styled from "styled-components";

const TitleContainer = styled(Layout)`
    min-height: 48px;
    width: 100%;
`;

export const useUnsavedChangesDialog = (modalHasUnsavedChanges, save) => {
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);
    const offsetClassNames = useModalOffset();

    const dispatch = useDispatch();

    const closeConfirmDialog = () => {
        dispatch(hideModal());
        setShowConfirmDialog(false);
    };

    const onConfirm = () => {
        save();
        closeConfirmDialog();
    };

    const openDialog = () => {
        if (modalHasUnsavedChanges()) {
            setShowConfirmDialog(true);
        } else {
            dispatch(hideModal());
        }
    };

    const title = (
        <TitleContainer vAlign="center">
            <Typography variant="label" size="xl">
                You have unsaved changes
            </Typography>
        </TitleContainer>
    );
    const content = <Typography>What do you want to do?</Typography>;
    const actions = (
        <Layout hAlign="flex-end" gap="--Spacing-150">
            <Button variant="text" dataCy="confirm-modal-cancel" onClick={closeConfirmDialog}>
                Close without saving
            </Button>
            <Button dataCy="confirm-modal-save" onClick={onConfirm}>
                Save and Close
            </Button>
        </Layout>
    );

    const dialog = showConfirmDialog ? (
        <Modal
            className={offsetClassNames}
            level="high"
            variant="dialog"
            topDivider
            bottomDivider={false}
            onClose={closeConfirmDialog}
            title={title}
            content={content}
            actions={actions}
        />
    ) : null;

    return [dialog, openDialog];
};

export default useUnsavedChangesDialog;
